import { app } from "./serviceLMS";
import { GET_COURSES_BUNDLE, USER_LOGIN, GOOGLE_LOGIN, EDIT_USER_DETAILS, CREATE_USER_DETAILS } from "./URLs";

export async function fetchUsers() {
  try {
    const response = await app.get("user/api/client-api/users");
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}

export async function userStats(userId, active) {
  try {
    const url = active
      ? `user/api/client-api/users/${userId}/statistics`
      : `user/api/client-api/users/${userId}/statistics?active=false`;

    const response = await app.get(url);
    return response.data;
  } catch (error) {
    console.log("userStat error");
    throw new Error(error?.response?.data?.message);
  }
}

export const fetchEnrolledItems = async (groupId) => {
  try {
    const response = await app.get(GET_COURSES_BUNDLE(groupId));
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

export async function userdeadlines() {
  try {

    const response = await app.get(
      'user/api/client-api/users/getDeadlines'
    );
    console.log("user deadlines response", response.data.data);

    return response.data.data;
  } catch (error) {
    console.log("userStat error");
    throw new Error(error?.response?.data?.message);
  }
}

export async function deleteUsers(id) {
  try {
    const response = await app.delete(`user/api/client-api/admin/remove-user/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}

export async function fetchAllUsers(
  page = 0,
  size = 10,
  search="",
  active="true",
  role,
) {
  try {
    const response = await app.get(
      "user/api/client-api/admin/users",
      {
        params: { page, size, sortBy:"createdAt", sortDir:"desc",search,active, filteredRole:role},
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return { data: [] };
    }
    throw new Error(error?.response?.data?.message);
  }
}


export async function fetchAllActiveUsersNonPaginated() {
  try {
    const response = await app.get("user/api/client-api/admin/active-employees");
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch active users." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching active users." };
  }
}

export async function fetchAddableUsersForGroup(groupId) {
  try {
    const response = await app.get(`user/api/client-api/group/${groupId}/addable-users`);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch addable users." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching addable users." };
  }
}

export async function fetchAllInactiveUsers(
  page = 0,
  size = 10,
  search="",
) {
  try {
    const response = await app.get(
      "user/api/client-api/admin/inactive-employees",
      {
        params: { page, size, sortBy:"createdAt", sortDir:"desc",search},
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return { data: [] };
    }
    throw new Error(error?.response?.data?.message);
  }
}

export async function fetchAllActiveUsers(
  page = 0,
  size = 10,
  sortBy = "createdAt",
  sortDir = "desc",
  search = ""
) {
  try {
    const params = { page, size, sortBy, sortDir };
    if (search && search.trim()) {
      params.search = search.trim();
    }

    const response = await app.get("user/api/client-api/admin/active-employees", {
      params,
    });

  return response.data;
} catch (error) {
  if (error.response && error.response.status === 404) {
    return { data: [] };
  }
  throw new Error(error?.response?.data?.message);
}
}

export async function createUser(userData) {
  try {
    const response = await app.post(`${CREATE_USER_DETAILS}`, userData);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Something went wrong");
  }
}

export async function updateUser(userData, userId) {
  try {
    const response = await app.patch(`${EDIT_USER_DETAILS}${userId}`, userData);
    console.log("Update User Response:", response.data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}

export async function countAllUsers() {
  try {
    const response = await app.get("user/api/client-api/user/userCount");
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}

export async function userLogin(data) {
  try {
    const response = await app.post(`${USER_LOGIN}`, data);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}

export async function googleLogin(data) {
  try {
    const response = await app.post(`${GOOGLE_LOGIN}`, data);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}

export async function logoutUser() {
  try {
    const response = await app.post("/api/client-api/auth/logout");
  }
  catch (error) {
    throw new Error(error?.response?.data?.message);
  }
  finally {
    window.localStorage.removeItem("authtoken");
    window.localStorage.removeItem("refreshToken");
    window.localStorage.removeItem("selectedId");
  }
}

export const previewUserReportPdf = async (options) => {
  return app
    .post(`user/api/client-api/custom-user-report/preview-pdf`, options, {
      responseType: "blob"
    })
    .then((res) => res.data);
};

export async function downloadUserReportPdf(options) {
  try {
    const response = await app.post(
      `user/api/client-api/custom-user-report/download-pdf`, options,
      {
        responseType: "blob"
      }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `user-report-${options.userId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading user report PDF:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to download user report PDF"
    );
  }
}

export async function downloadUserReportExcel(options) {
  try {
    const response = await app.post(
      `user/api/client-api/custom-user-report/download-excel`, options,
      {
        responseType: "blob"
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `user-report-${options.userId}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading user report Excel:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to download user report Excel"
    );
  }
}

export const resetPassword = async (payload) => {
  try {
    const response = await app.post("api/client-api/auth/reset-password", payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export async function sendForgotPassword(data) {
  try {
    const response = await app.post("/api/client-api/auth/forgot-password", data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
}

export async function sendNewPassword(data) {
  try {
    const response = await app.post("/api/client-api/auth/set-password", data);
    
    if (response.status >= 200 && response.status < 300) {
      return {
        success: true,
        code: response.data.code || "SUCCESS",
        message: response.data.message || "Password updated successfully!",
        data: response.data
      };
    }
    
    throw new Error(response.data?.message || "Unexpected response from server");
    
  } catch (error) {
    if (error.response) {
      const errorData = error.response.data;
      
      return {
        success: false,
        code: errorData.code || "UNKNOWN_ERROR",
        message: errorData.message || "Failed to reset password",
        statusCode: error.response.status
      };
    }
    
    return {
      success: false,
      code: "NETWORK_ERROR",
      message: error.message || "Network error. Please check your connection and try again.",
      statusCode: null
    };
  }
}